import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import FullScreenLoader from '@frontend/components/FullScreenLoader';
import { useNamespacedNavigate } from '@frontend/hooks';

import { useUnifiedAgentByHumanReadableId } from '../hooks';

export function AgentRouterPage() {
  const params = useParams();
  const navigate = useNamespacedNavigate();

  const agentIdFromUrl = params.humanReadableAgentId;
  const { agent, agentType } = useUnifiedAgentByHumanReadableId(agentIdFromUrl || '');

  useEffect(() => {
    if (agent && agentType) {
      if (agentType === 'specialized') {
        navigate(`/agents/specialized/${agent.id}`);
      } else if (agentType === 'workflow') {
        navigate(`/agents/workflow/edit/${agent.id}`);
      }
    }
  }, [agent, agentType, navigate]);

  return <FullScreenLoader />;
}
